$(document).ready(function () {
  setTimeout(() => {
     if ($("#shopify-section-spin_to_win_v2").length) {
        $(".spt_trigger").click(function () {
        $(".stw_outer").css("display", "flex");
    }),
        $(".stw_btn_trigger.try_luck_btn").click(function (e) {          e.preventDefault();
            $(".try_luck_wrapper").hide(), $(".stw_before_submit").show(), $(".stw_main_bg").hasClass("mocking_spin") && $(".stw_main_bg").removeClass("mocking_spin"), $(".stw_main_bg").addClass("activated");
        }),
        $(".stw_btn_trigger.spin_trigger").click(function (e) {
          e.preventDefault();
            var emailChecker;
            $(".stw_before_submit").find("input").trigger("click"),
                setTimeout(function () {
                    emailChecker = $(".stw_before_submit .klaviyo-form").find("#klaviyo_ariaid_2").html();
                    var currentInputVal = $(".stw_before_submit .klaviyo-form input").val();
                    if (emailChecker == "This field is required" || currentInputVal == "") console.log("field is required");
                    else {
                        $(".stw_main_bg").removeClass("activated");
                        let currentRotation = getCurrentRotation($(".stw_main_bg"));
                        $(".stw_main_bg").removeClass("activated"),
                            $(".stw_main_bg").css({ animation: "4s cubic-bezier(0.11, 0.45, 0.57, 1.03) 0s 1 normal forwards running spinning_slowing_and_stop", transform: `rotate(${currentRotation + 2880}deg)` }),
                            $(".stw_before_submit").hide(),
                            $(".wheel_stopping").show(),
                            $(".stw_close_text").hide(),
                            setTimeout(function () {
                                $(".stw_outer").addClass("won1"),
                                    $(".wheel_stopping").hide(),
                                    $("#canvas").show(),
                                    (canvas.width = W),
                                    (canvas.height = H),
                                    requestAnimationFrame(Draw),
                                    $(".stw_main").hide(),
                                    $(".stw_middle_circl").hide(),
                                    $(".stw_inn").css("border", "none"),
                                    $(".stw_finished").show(),
                                    $("#confeti-img").show(),
                                    $(".stw_inn").css("background", "none"),
                                    $(".stw_inn").css("box-shadow", "none");
                            }, 5e3);
                    }
                }, 200);
        }),
        $(".stw_btn_trigger.upgrade_trigger").click(function (e) {
                    e.preventDefault();
            var emailChecker;
            $(".stw_next_submit").find("input").trigger("click");
            var currentInputVal = $(".stw_next_submit .klaviyo-form input").val();
            setTimeout(function () {
                (emailChecker = $(".stw_next_submit .klaviyo-form").find("#klaviyo_ariaid_4").html()),
                    console.log(emailChecker, " email checker"),
                    emailChecker == "This field is required" || currentInputVal == "" || emailChecker == "This number is invalid"
                        ? console.log("field is required")
                        : (console.log("here is activated"),
                          $(".stw_main_bg").addClass("activated"),
                          setTimeout(function () {
                              $(".stw_outer").removeClass("won1"), $(".stw_outer").addClass("won"), $(".stw_close_text2").hide();
                          }, 500));
            }, 200);
        }),
        $(".stw_close_text_inside").click(function () {
            $(".stw_outer").hide();
        }),
        $(".stw_close_text2").click(function () {
            $(".stw_outer").hide();
        }),
        $(".stw_close_btn_pop").click(function () {
            $(".stw_outer").hide();
        }),
        $(".stw_close_text").click(function () {
            $(".stw_outer").hide();
        });
    function getCurrentRotation(el) {
        const tr = window.getComputedStyle(el[0], null).getPropertyValue("transform");
        if (tr !== "none") {
            const values = tr.split("(")[1].split(")")[0].split(","),
                a = values[0],
                b = values[1],
                angle = Math.round(Math.atan2(b, a) * (180 / Math.PI));
            return angle < 0 ? angle + 360 : angle;
        }
        return 0;
    }
    let W = window.innerWidth,
        H = window.innerHeight;
    const canvas = document.getElementById("canvas"),
        context = canvas.getContext("2d"),
        maxConfettis = 150,
        particles = [],
        possibleColors = ["DodgerBlue", "OliveDrab", "Gold", "Pink", "SlateBlue", "LightBlue", "Gold", "Violet", "PaleGreen", "SteelBlue", "SandyBrown", "Chocolate", "Crimson"];
    let totalAnimationTime = 8e3,
        startTime = null,
        stopResettingParticles = !1;
    function randomFromTo(from, to) {
        return Math.floor(Math.random() * (to - from + 1) + from);
    }
    function confettiParticle() {
        (this.x = Math.random() * W),
            (this.y = Math.random() * H - H),
            (this.r = randomFromTo(11, 33)),
            (this.d = Math.random() * maxConfettis + 11),
            (this.color = possibleColors[Math.floor(Math.random() * possibleColors.length)]),
            (this.tilt = Math.floor(Math.random() * 33) - 11),
            (this.tiltAngleIncremental = Math.random() * 0.07 + 0.05),
            (this.tiltAngle = 0),
            (this.draw = function () {
                return (
                    context.beginPath(),
                    (context.lineWidth = this.r / 2),
                    (context.strokeStyle = this.color),
                    context.moveTo(this.x + this.tilt + this.r / 3, this.y),
                    context.lineTo(this.x + this.tilt, this.y + this.tilt + this.r / 5),
                    context.stroke()
                );
            });
    }
    function Draw(timestamp) {
        startTime || (startTime = timestamp);
        const elapsedTime = timestamp - startTime;
        if ((context.clearRect(0, 0, W, H), elapsedTime < 4e3)) {
            for (let i = 0; i < maxConfettis; i++) particles[i].draw();
            let particle = {};
            for (let i = 0; i < maxConfettis; i++)
                (particle = particles[i]),
                    (particle.tiltAngle += particle.tiltAngleIncremental),
                    (particle.y += (Math.cos(particle.d) + 3 + particle.r / 2) / 2),
                    (particle.tilt = Math.sin(particle.tiltAngle - i / 3) * 15),
                    stopResettingParticles || ((particle.x > W + 30 || particle.x < -30 || particle.y > H) && ((particle.x = Math.random() * W), (particle.y = -30), (particle.tilt = Math.floor(Math.random() * 10) - 20)));
        }
        if (elapsedTime >= 4e3 && elapsedTime < totalAnimationTime) {
            stopResettingParticles = !0;
            for (let i = 0; i < maxConfettis; i++) {
                let particle = particles[i];
                (particle.tiltAngle += particle.tiltAngleIncremental), (particle.y += (Math.cos(particle.d) + 3 + particle.r / 2) / 2), (particle.tilt = Math.sin(particle.tiltAngle - i / 3) * 15), particle.draw();
            }
        }
        elapsedTime < totalAnimationTime && requestAnimationFrame(Draw);
    }
    window.addEventListener(
        "resize",
        function () {
            (W = window.innerWidth), (H = window.innerHeight), (canvas.width = window.innerWidth), (canvas.height = window.innerHeight);
        },
        !1
    );
    for (let i = 0; i < maxConfettis; i++) particles.push(new confettiParticle());
  } else {
    $(".spt_trigger").click(function () {
      $(".stw_outer").css("display", "flex");
    });

    $(".stw_btn_trigger.spin_trigger").click(function () {
      var emailChecker;
      $(".stw_before_submit").find("input").trigger("click");
      setTimeout(function () {
        emailChecker = $(".stw_before_submit .klaviyo-form")
          .find("#klaviyo_ariaid_2")
          .html();
        console.log(emailChecker, " email checker");
        var currentInputVal = $(".stw_before_submit .klaviyo-form input").val();

        if (emailChecker == "This field is required" || currentInputVal == "") {
          console.log("field is required");
        } else {
          $(".stw_main_bg").addClass("activated");
          $(".stw_close_text").hide();
          setTimeout(function () {
            $(".stw_outer").addClass("won1");
            $(".stw_close_text2").show();
          }, 3500);
        }
      }, 200);
    });

    $(".stw_btn_trigger.upgrade_trigger").click(function () {
      var emailChecker;
      $(".stw_next_submit").find("input").trigger("click");
      var currentInputVal = $(".stw_next_submit .klaviyo-form input").val();
      setTimeout(function () {
        emailChecker = $(".stw_next_submit .klaviyo-form")
          .find("#klaviyo_ariaid_4")
          .html();
        console.log(emailChecker, " email checker");

        if (emailChecker == "This field is required" || currentInputVal == "") {
          console.log("field is required");
        } else {
          $(".stw_main_bg").addClass("activated");
          setTimeout(function () {
            $(".stw_outer").removeClass("won1");
            $(".stw_outer").addClass("won");
            $(".stw_close_text2").hide();
          }, 500);
        }
      }, 200);
    });

    $(".stw_close_text2").click(function () {
      $(".stw_outer").hide();
    });

    $(".stw_close_btn_pop").click(function () {
      $(".stw_outer").hide();
    });

    $(".stw_close_text").click(function () {
      $(".stw_outer").hide();
    });
  }
  },500)
});
